import { render, staticRenderFns } from "./DenominationPopin.vue?vue&type=template&id=ff7c9e5a"
import script from "./DenominationPopin.vue?vue&type=script&lang=js"
export * from "./DenominationPopin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff7c9e5a')) {
      api.createRecord('ff7c9e5a', component.options)
    } else {
      api.reload('ff7c9e5a', component.options)
    }
    module.hot.accept("./DenominationPopin.vue?vue&type=template&id=ff7c9e5a", function () {
      api.rerender('ff7c9e5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/appellation/DenominationPopin.vue"
export default component.exports